// Loop-scope construction helpers for each @for iteration.
// Example: value "{ name: sm; size: 640px; }" creates scope keys `bp.name`.
import { isObjectVariableValue, parseObjectVariable } from '../../variables/object-variable'
import type { LoopScope } from './types'

// Build per-iteration loop scope and expand object-item keys when available.
export function createLoopIterationScope(
  scope: LoopScope,
  variableName: string,
  value: string,
  iterationIndex: number,
  indexVariableName?: string,
): LoopScope {
  const nextScope: LoopScope = { ...scope, [variableName]: value }
  // Add optional index variable when tuple target defines one.
  if (indexVariableName) {
    nextScope[indexVariableName] = String(iterationIndex)
  } else {
    // Keep scope unchanged when index variable is not configured.
  }
  const trimmedValue = value.trim()
  // Skip object key expansion when loop item is not object-like.
  if (!isObjectVariableValue(trimmedValue)) {
    // Return scope with direct loop variable only.
    return nextScope
  } else {
    // Continue with object key expansion.
  }

  const objectValue = parseObjectVariable(trimmedValue)
  // Add `loopVar.key` aliases so `${bp.size}` resolves directly.
  for (const [key, keyValue] of Object.entries(objectValue)) {
    nextScope[`${variableName}.${key}`] = keyValue
  }

  // Return scope enriched with object member aliases.
  return nextScope
}
